/**
 * PDP „Titel/Subheadline auf Mobile über den Medien“: verschiebt die echten Text-Blöcke
 * (inkl. Typografie, Farben, Padding aus den Block-Settings) in Slots oberhalb der Galerie.
 *
 * Nach appendChild liegen Knoten nicht mehr unter .product-details — Suche daher immer
 * auch in den Slots (Resize, Theme-Editor).
 */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';
  var debounceTimer;

  /**
   * @param {Element} root
   * @param {Element | null} slot
   * @returns {Element | null}
   */
  function findTitleBlock(root, slot) {
    var inDetails = root.querySelector('.product-details [data-product-title-mobile]');
    if (inDetails) return inDetails;
    if (slot) {
      var inSlot = slot.querySelector('[data-product-title-mobile]');
      if (inSlot) return inSlot;
    }
    return null;
  }

  /**
   * @param {Element} root
   * @param {Element | null} slot
   * @returns {Element | null}
   */
  function findSubheadlineBlock(root, slot) {
    var inDetails = root.querySelector('.product-details [data-product-subheadline]');
    if (inDetails) return inDetails;
    if (slot) {
      var inSlot = slot.querySelector('[data-product-subheadline]');
      if (inSlot) return inSlot;
    }
    var fbDetails = root.querySelector('.product-details .text-block--text_product_subheadline');
    if (fbDetails) return fbDetails;
    if (slot) {
      var fbSlot = slot.querySelector('.text-block--text_product_subheadline');
      if (fbSlot) return fbSlot;
    }
    return null;
  }

  /**
   * @param {Element} root
   * @param {boolean} mobile
   * @param {string} slotSelector
   * @param {function(Element, Element | null): Element | null} findBlock
   * @param {string} returnKey
   */
  function moveBlock(root, mobile, slotSelector, findBlock, returnKey) {
    var slot = root.querySelector(slotSelector);
    var block = findBlock(root, slot);
    if (!slot || !block) return;

    if (mobile) {
      if (block.parentElement !== slot) {
        if (!block[returnKey]) {
          block[returnKey] = { parent: block.parentElement, next: block.nextSibling };
        }
        slot.appendChild(block);
      }
    } else {
      var ref = block[returnKey];
      if (ref && ref.parent && ref.parent.isConnected) {
        ref.parent.insertBefore(block, ref.next);
        delete block[returnKey];
      }
    }
  }

  function sync() {
    var roots = document.querySelectorAll('.product-information--mobile-title-above');
    var mobile = window.matchMedia(MOBILE_MQ).matches;
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      moveBlock(root, mobile, '[data-product-title-mobile-slot]', findTitleBlock, '__pdpTitleReturn');
      moveBlock(root, mobile, '[data-product-subheadline-slot]', findSubheadlineBlock, '__pdpSubReturn');
    }
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 60);
  }

  function bindEditorEvents() {
    if (typeof Shopify === 'undefined' || !Shopify.designMode) return;
    document.addEventListener('shopify:block:select', scheduleSync);
    document.addEventListener('shopify:block:deselect', scheduleSync);
    document.addEventListener('shopify:section:select', scheduleSync);
    document.addEventListener('shopify:section:deselect', scheduleSync);
  }

  function init() {
    if (window.__pdpMobileHeaderOrderBound) {
      sync();
      return;
    }
    window.__pdpMobileHeaderOrderBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }

    window.matchMedia(MOBILE_MQ).addEventListener('change', sync);
    document.addEventListener('shopify:section:load', scheduleSync);
    bindEditorEvents();
  }

  init();
})();
